"use client";

import React, { useEffect, useState } from "react";
import { usePathname } from "next/navigation";

export function ScrollProgress() {
  const pathname = usePathname();
  const [progress, setProgress] = useState(0);

  const isCrm = Boolean(pathname?.startsWith("/crm"));

  useEffect(() => {
    if (isCrm) return;
    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
      const windowHeight = scrollHeight - clientHeight;
      if (windowHeight <= 0) {
        setProgress(0);
        return;
      }
      const scrolled = (scrollTop / windowHeight) * 100;
      setProgress(Math.min(100, Math.max(0, scrolled)));
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (isCrm || progress <= 0) return null;

  return (
    <div className="fixed top-0 left-0 right-0 h-[3px] z-[60] pointer-events-none print:hidden">
      <div
        className="h-full bg-gradient-to-r from-blue-600 via-cyan-400 to-emerald-400 transition-[width] duration-150 ease-out shadow-[0_0_12px_rgba(6,182,212,0.6)]"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
}
